module.exports = __webpack_public_path__ + "img/name.37180120.png";